import icons from '../../img/icons.svg';
import View from './View.js';

class SearchView extends View {
  _parentElement = document.querySelector('.search');
  _searchField = document.querySelector('.search__field');
  _errorMsg = 'Please enter something!'

  getQuery() {
    const searchInput = this._searchField.value;
    this._clearInput();
    return searchInput;
  }

  _clearInput() {
    this._searchField.value = '';
  }

  addHandlerSearch(handler) {
    this._parentElement.addEventListener('submit', function (event) {
      event.preventDefault();
      handler();
    });
  }
}

export default new SearchView();
